module.exports = __webpack_public_path__ + "img/Hypoxia-OVCA_10X_OC.9b2260ef.png";